import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { FaCheckCircle, FaGithub, FaLink } from "react-icons/fa";
import { useParams } from "react-router";
import "./SingleProject.css";

const ProjectImage = ({ src, alt, className = "" }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={`project-image-card ${className}`}>
      {loading && (
        <div className="project-image-loader" aria-label="Loading project image">
          <span />
        </div>
      )}
      <img
        className={`project-detail-image ${loading ? "is-loading" : ""}`}
        src={src}
        alt={alt}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  );
};

const SingleProject = () => {
  const { projectId } = useParams();

  const [singleProject, setSingleProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/projectData.json")
      .then((res) => res.json())
      .then((data) => setSingleProject(data.find((project) => project.id === projectId)))
      .catch(() => setSingleProject(null))
      .finally(() => setLoading(false));
  }, [projectId]);

  if (loading) {
    return (
      <div className="single-project-page project-loading-page">
        <div className="page-loader" aria-label="Loading project details">
          <span />
        </div>
      </div>
    );
  }

  if (!singleProject) {
    return (
      <div className="single-project-page project-empty-state">
        <p className="section-kicker">
          <span /> Project not found
        </p>
        <h1>This project is unavailable.</h1>
      </div>
    );
  }

  return (
    <div className="single-project-page">
      <Container>
        <header className="project-detail-header">
          <p className="section-kicker">
            <span /> Case study / {String(projectId).padStart(2, "0")}
          </p>
          <h1>{singleProject.title}</h1>
          <p className="project-detail-description">{singleProject.description}</p>
          <div className="project-detail-actions">
            <a
              href={singleProject.liveLink}
              className="project-action project-action-primary"
              target="_blank"
              rel="noreferrer"
            >
              <FaLink /> Visit live site
            </a>
            <a href={singleProject.clientSideRepository} className="project-action" target="_blank" rel="noreferrer">
              <FaGithub /> View source
            </a>
          </div>
        </header>

        <Row className="project-gallery g-3">
          {[singleProject.image1, singleProject.image2, singleProject.image3].map((image, index) => (
            <div className="col-12 col-md-4" key={image}>
              <ProjectImage src={image} alt={`${singleProject.title} screen ${index + 1}`} />
            </div>
          ))}
        </Row>

        <section className="project-info-panel" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000">
          <div className="project-info-heading">
            <p className="section-kicker">
              <span /> Built with
            </p>
            <h2>
              Tools behind
              <br />
              <em>the work.</em>
            </h2>
          </div>
          <div className="technology-list">
            {singleProject.tools?.map((tool) => (
              <span className="technology-item" key={tool}>
                <FaCheckCircle /> {tool}
              </span>
            ))}
          </div>
        </section>
      </Container>
    </div>
  );
};

export default SingleProject;
